import React from 'react'
import PageError from 'shared/components/PageError'

interface IProps {
  children?: React.ReactNode
}

class ErrorBoundary extends React.Component<IProps> {
  state = {
    hasError: false,
  }
  constructor(props: IProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    console.log(error)
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log(error)
    console.log(errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <PageError />
    }

    return this.props.children
  }
}

export default ErrorBoundary
